import React from "react";
import ReactRecaptcha from "react-google-invisible-recaptcha";
import "../../resources/css/application.css";
import * as PropTypes from "prop-types";
import {ENV} from "../../util/Util";

const Recaptcha = (props) => {

  const {reCaptchaRef, setReCaptchaResponse} = props;

  const onRecaptchaResolved = () => {
    return new Promise(function (resolve, reject,) {
      if (reCaptchaRef.current === undefined) {
        return reject;
      }
      if (!reCaptchaRef.current.getResponse()) {
        return reject;
      }
      setReCaptchaResponse(reCaptchaRef.current.getResponse());
      return resolve;
    });
  };

  const onRecaptchaLoaded = () => {
    console.log("Recaptcha successfully loaded!")
  };

  return (
    <div>
      <ReactRecaptcha ref={reCaptchaRef}
                      sitekey={ENV.REACT_APP_RECAPTCHA_SITE_KEY}
                      badge={"inline"}
                      onResolved={onRecaptchaResolved}
                      onLoaded={onRecaptchaLoaded}/>
    </div>
  );
};

Recaptcha.propTypes = {
  reCaptchaRef: PropTypes.object.isRequired,
  setReCaptchaResponse: PropTypes.func.isRequired
};

export default Recaptcha;
